import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { isPlatformBrowser } from '@angular/common';

/**
 * Error interceptor that handles authentication errors
 * Redirects to login on 401 Unauthorized responses
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                // Token is invalid or expired
                const authService = inject(AuthService);

                if (isPlatformBrowser(platformId)) {
                    // Store current URL for redirect after login
                    sessionStorage.setItem('returnUrl', router.url);

                    // Trigger sign-in flow
                    authService.signIn();
                }
            }
            return throwError(() => error);
        })
    );
};
